/* eslint-disable */
import axios from "axios";

export async function setGroupAPI (params) {
	let responseData = null
	await axios
		.post('groups', params)
		.then(response => {
			console.log("SET GROUP SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("SET GROUP ERROR", error);
		})
	return responseData
}

export async function updateGroupAPI (params) {
	let responseData = null
	await axios
		.patch(`groups/${params.id}`, params)
		.then(response => {
			console.log("UPDATE GROUP SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("UPDATE GROUP ERROR", error);
		})
	return responseData
}

export async function getGroupsAPI ({ params }) {
	let responseData = null
	await axios
		.get('groups', {
			params
		})
		.then(response => {
			console.log("GET GROUP SUCCESS", response);
			responseData = {
				data: response.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("GET GROUP ERROR", error);
		})
	return responseData
}

export async function getGroupAPI ({ id }) {
	let responseData = null
	await axios
		.get(`groups/${id}`)
		.then(response => {
			console.log("GET GROUPS SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("GET GROUPS ERROR", error);
		})
	return responseData
}

export async function removeGroupAPI ({ id }) {
	let responseData = null
	await axios
		.delete(`groups/${id}`)
		.then(response => {
			console.log("DELETE GROUP SUCCESS", response);
			responseData = {
				data: response.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("DELETE GROUP ERROR", error);
		})
	return responseData
}

export async function removeGroupUserAPI ({ group_id, user_id }) {
	let responseData = null
	await axios
		.delete(`groups/${group_id}/delete-user`, {
			params: {
				user_id
			}
		})
		.then(response => {
			console.log("DELETE GROUP USER SUCCESS", response);
			responseData = {
				data: response.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("DELETE GROUP USER ERROR", error);
		})
	return responseData
}

export async function requestToJoinGroupAPI ({ id }) {
	let responseData = null
	await axios
		.post(`groups/${id}/request-to-join`)
		.then(response => {
			console.log("REQUEST TO JOIN SUCCESS", response);
			responseData = {
				data: response.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("REQUEST TO JOIN ERROR", error);
		})
	return responseData
}

export async function getUsersToInviteAPI ({ id, params = null }) {
	let responseData = null
	await axios
		.get(`groups/${id}/users-to-invite`, {
			params: params
		})
		.then(response => {
			console.log("GET GROUP USERS TO INVITE SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("GET GROUP USERS TO INVITE ERROR", error);
		})
	return responseData
}

export async function getUsersAPI ({ id, params = null }) {
	let responseData = null
	await axios
		.get(`groups/${id}/users`, {
			params
		})
		.then(response => {
			console.log("GET GROUP USERS SUCCESS", response);
			responseData = {
				data: response.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("GET GROUP USERS ERROR", error);
		})
	return responseData
}

export async function getUserGroupsAPI ({ id, params }) {
	let responseData = null
	await axios
		.get(`groups/user-groups/${id}`, {
			params
		})
		.then(response => {
			console.log("GET USER GROUPS SUCCESS", response);
			responseData = {
				data: response.data,
				success: true
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("GET USER GROUPS ERROR", error);
		})
	return responseData
}

export async function getUserRequestsAPI () {
	let responseData = null
	await axios
		.get(`groups/my-requests`)
		.then(response => {
			console.log("GET USER JOIN REQUESTS SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true
			}
		})
		.catch(error => {
			console.log("GET USER JOIN REQUESTS ERROR", error);
		})
	return responseData
}

export async function inviteUsersToGroupAPI ({ id, user_ids}) {
	let responseData = null
	await axios
		.post(`groups/${id}/invite-users`, {
			user_ids
		})
		.then(response => {
			console.log("GET USER JOIN REQUESTS SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true
			}
		})
		.catch(error => {
			console.log("GET USER JOIN REQUESTS ERROR", error);
		})
	return responseData
}

export async function getGroupPostsAPI ({ id, params = null }) {
	let responseData = null
	await axios
		.get(`posts/group/${id}`, {
			params
		})
		.then(response => {
			console.log("GET GROUP POSTS SUCCESS", response);
			responseData = {
				data: response.data,
				success: true
			}
		})
		.catch(error => {
			console.log("GET GROUP POSTS ERROR", error);
		})
	return responseData
}

export async function getGroupRequestsAPI ({ id, params }) {
	let responseData = null
	await axios
		.get(`/groups/${id}/requests`, {
			params
		})
		.then(response => {
			console.log("GET GROUP REQUESTS SUCCESS", response);
			responseData = {
				data: response.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("GET GROUP REQUESTS ERROR", error);
		})
	return responseData
}

export async function changeGroupUserRoleAPI ({ id, params }) {
	let responseData = null
	await axios
		.post(`groups/${id}/change-role`, params)
		.then(response => {
			console.log("CHANGE GROUP USER ROLE SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false
			}
			console.log("CHANGE GROUP USER ROLE ERROR", error);
		})
	return responseData
}

export async function leaveGroupAPI ({ id }) {
	let responseData = null
	await axios
		.post(`groups/${id}/leave`)
		.then(response => {
			console.log("LEAVE GROUP USER ROLE SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("LEAVE GROUP USER ROLE ERROR", error);
		})
	return responseData
}

export async function acceptRejectUserAPI ({ id, status, user_id }) {
	let responseData = null
	await axios
		.post(`groups/${id}/accept-reject-user`, {
			status,
			user_id
		})
		.then(response => {
			console.log("ACCEPT REJECT USER SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: null
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("ACCEPT REJECT USER ERROR", error);
		})
	return responseData
}

export async function acceptRejectGroupAPI ({ id, status, user_id }) {
	let responseData = null
	await axios
		.post(`groups/${id}/accept-reject-group`, {
			status,
			user_id
		})
		.then(response => {
			console.log("ACCEPT REJECT GROUP SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("ACCEPT REJECT GROUP ERROR", error);
		})
	return responseData
}

export async function cancelRequestGroupAPI ({ id }) {
	let responseData = null
	await axios
		.post(`groups/${id}/cancel-request`)
		.then(response => {
			console.log("CANCEL REQUEST GROUP SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true,
				error: false
			}
		})
		.catch(error => {
			responseData = {
				data: null,
				success: false,
				error: error
			}
			console.log("CANCEL REQUEST GROUP ERROR", error);
		})
	return responseData
}


